/*** IMPORTS FROM imports-loader ***/
(function() {

define(['jquery', 'mustache', 'pip-model', 'pip-domain', 'pip-common.utils', 'pip-analytics__multi-sku-bulk', 'pip-events'], function($, Mustache, pip, pipDomain, pipCommonUtils, multiSkuBulkAnalytics, pipEvents) {
  var view = {
    selectors: {
      msbMessage: '.msbMessage',
      msbItemList: '.msbItemList',
      msbEligibleButton: '.msbMessage__eligibleLink',
      msbItemListReference: '.msb__container',
      msbBoxContents: '.msbSelectedItem__itemDetails',
      msbListElement: '.msb__listElement',
      msbAddToCartButton: '.msbSelectedItem__quantity--addToCart-button',
      msbIncrement: '.msbSelectedItem__quantityButtons-increment',
      msbDecrement: '.msbSelectedItem__quantityButtons-decrement',
      msbQuantityInput: '.msbSelectedItem__quantityButtons-input',
      msbQuantityError: '.msb__quantity-error-message',
      msbImageOverlayCartQuantity: '.msbSelectedItem__itemSelectedImageOverlay--quantity',
      msbSavingsError: '.msbSavingsError',
      msbItemSelectedImageOverlay: '.msbSelectedItem__itemSelectedImageOverlay',
      msbSelectedImageText: '.msbSelectedItem__itemSelectedImageOverlay--text',
      msbOverlaySpinnerContainer: '.msb__itemSelectedImageOverlay_spinner-container',
      msbLoadError: '.msbLoadError',
      msbQuantityCircle: '.msb__circle',
      msbSavingsApplied: '.msbSavingsApplied',
      msbSavingsAppliedText: '.msbSavingsAppliedText',
      msbListItemElementQuantityCircle: function msbListItemElementQuantityCircle(itemId) {
        return '.msb__listElement[data-itemId=' + itemId + '] .msb__circle';
      }
    },
    classes: {
      hideClass: 'u--hide',
      msbElementSelected: 'msb__elementSelected',
      msbTrashCanIcon: 'msb__trashCanIcon',
      quantityError: 'msb__quantity-error',
      disabled: 'disabled',
      bgColorFaded: 'u__bgColor--faded'
    },
    constants: {
      shipToHome: 'ShipToHome',
      bopis: 'BOPIS',
      msbKey: 'multiSkuBulkProducts',
      cartUpdateURI: '/mcc-cart/v2/Cart/update/',
      addToCartURI: '/mcc-cart/v2/Cart/',
      cartLiteURI: '/mcc-cart/v2/Cart/lite',
      msbInfoURI: '/p/svcs/getMultipleProductsInfo/',
      maxCacheLength: 10
    },
    templates: {
      msbTemplate: $('#msb_item_list').html(),
      msbMessage: $('#msb_message').html(),
      msbSelectedItem: $('#msb_selected_item').html(),
      msbCartUpdateSpinner: $('#msb_cart_update_spinner').html()
    },
    render: {
      msbItemList: function msbItemList() {
        if ($(window) && $(window)[0].digitalData.content.module.length < 2) {
          pipEvents.multiSkuBulk.multiSkuBulkAnalytics.trigger();
        }
        return Mustache.render(view.templates.msbTemplate, { multiSkuBulkProducts: viewModel.sortByMainProduct() });
      },
      msbMessage: function msbMessage() {
        return Mustache.render(view.templates.msbMessage, viewModel.multiSkuBulkPromotion);
      },
      msbSelectedItem: function msbSelectedItem() {
        return Mustache.render(view.templates.msbSelectedItem, viewModel.selectedItem);
      }
    },
    updateDOM: {
      msbItemList: function msbItemList() {
        $(view.selectors.msbItemList).html(view.render.msbItemList());
      },
      msbMessage: function msbMessage() {
        $(view.selectors.msbMessage).html(view.render.msbMessage());
      },
      msbSelectedItem: function msbSelectedItem() {
        $(view.selectors.msbBoxContents).html(view.render.msbSelectedItem());
        view.checkDecrementCount();
      }
    },
    initEventListeners: function initEventListeners() {
      viewModel.listenerAdded = true;
      $(window.document).off('msBulk');
      $(window.document).on('click.msBulk', view.selectors.msbEligibleButton, function(e) {
        e.preventDefault();
        view.initView();
      });
      $(window.document).on('click.msBulk', view.selectors.msbListElement, function(e) {
        var currentTarget = $(e.currentTarget);
        if (currentTarget.hasClass('disabled') || currentTarget.hasClass(view.classes.msbElementSelected)) {
          return false;
        }

        var targetId = currentTarget.attr('data-itemid');
        currentTarget.siblings().toggleClass(view.classes.msbElementSelected, false);
        currentTarget.toggleClass(view.classes.msbElementSelected, true);
        viewModel.selectedItem = viewModel.idMap[targetId];
        view.updateDOM.msbSelectedItem();
      });
      $(window.document).on('click.msBulk', view.selectors.msbAddToCartButton, function() {
        var fulfillmentMethod = '';
        for (var fulfillmentIndex = 0; fulfillmentIndex < viewModel.selectedItem.fulfillments.length; fulfillmentIndex++) {
          if (viewModel.selectedItem.fulfillments[fulfillmentIndex].fulfillment === view.constants.shipToHome) {
            fulfillmentMethod = view.constants.shipToHome;
            break;
          }
          if (viewModel.selectedItem.fulfillments[fulfillmentIndex].fulfillment === view.constants.bopis) {
            fulfillmentMethod = view.constants.bopis;
          }
        }
        var atcData = {
          itemId: viewModel.selectedItem.itemId,
          quantity: 1,
          fulfillmentMethod: fulfillmentMethod
        };
        viewModel.addToCartDirect(atcData, { success: view.onSuccessAddToCart, error: view.onCartError, before: view.beforeCart, isCartIncrease: true });
      });
      $(window.document).on('click.msBulk', view.selectors.msbDecrement, function() {
        if ($(view.selectors.msbDecrement).hasClass(view.classes.disabled)) {
          return false;
        }
        var inputQuantity = viewModel.selectedItem.cartQuantity - 1;
        viewModel.onItemQuantityReduced(inputQuantity);
      });
      $(window.document).on('blur.msBulk keyup.msBulk', view.selectors.msbQuantityInput, function(e) {
        var quantityInput = $(view.selectors.msbQuantityInput);
        if (quantityInput.attr('readonly') !== 'readonly' && (e.type === 'focusout' || e.keyCode === 13)) {
          var inputQuantity = parseInt(quantityInput.val());
          if (isNaN(inputQuantity)) {
            $(view.selectors.msbQuantityInput).val(viewModel.selectedItem.cartQuantity);
          }
          else if (viewModel.selectedItem.cartQuantity > inputQuantity) {
            viewModel.onItemQuantityReduced(inputQuantity);
          } else if (viewModel.selectedItem.cartQuantity < inputQuantity) {
            viewModel.onItemQuantityIncreased(inputQuantity);
          }
        }
      });
      $(window.document).on('click.msBulk', view.selectors.msbIncrement, function() {
        if ($(view.selectors.msbIncrement).hasClass(view.classes.disabled)) {
          return false;
        }
        var inputQuantity = viewModel.selectedItem.cartQuantity + 1;
        viewModel.onItemQuantityIncreased(inputQuantity);
      });
    },
    initView: function initView(forceInit) {
      if (forceInit || viewModel.selectedItem.itemId || viewModel.checkSwatchPartOfPromo()) {
        $(view.selectors.msbLoadError).addClass(view.classes.hideClass);
        model.fetch.msbModel().done(
          function(data) {
            if (data.isCached) {
              viewModel.idMap = data.multiSkuBulkProducts;
              viewModel.selectedItem = viewModel.idMap[pip.products.primary.data.itemId] || viewModel.idMap[Object.keys(viewModel.idMap)[0]];
              view.updateView();
              viewModel.updateCartQuantityInItemList();
            } else {
              if (data.multiSkuBulkProducts.length > 0) {
                viewModel.buildIdMap(data);
                viewModel.selectedItem = viewModel.idMap[pip.products.primary.data.itemId] || viewModel.idMap[Object.keys(viewModel.idMap)[0]];
                view.updateView();
                viewModel.isExpanded = true;
                viewModel.updateCartQuantityFromMyCart();
                viewModel.productInfoCache.add(viewModel.multiSkuBulkPromotion.promotionId, viewModel.idMap);
              } else {
                $(view.selectors.msbLoadError).removeClass(view.classes.hideClass);
              }
            }
            viewModel.currentPromotionId = viewModel.multiSkuBulkPromotion.promotionId;
          }
        ).fail(function() {
          $(view.selectors.msbLoadError).removeClass(view.classes.hideClass);
        });
      }
    },
    updateView: function updateView() {
      view.updateDOM.msbItemList();
      view.updateDOM.msbSelectedItem();
      $(view.selectors.msbListElement).first().toggleClass(view.classes.msbElementSelected, true);
    },
    checkDecrementCount: function checkDecrementCount() {
      if (viewModel.selectedItem.cartQuantity === 1) {
        $(view.selectors.msbDecrement).toggleClass(view.classes.msbTrashCanIcon, true);
        $(view.selectors.msbDecrement).text("");
      } else {
        $(view.selectors.msbDecrement).toggleClass(view.classes.msbTrashCanIcon, false);
        $(view.selectors.msbDecrement).text('-');
      }
    },
    showItemQuantityExceedError: function showItemQuantityExceedError(totalAvailableQuantity) {
      $(view.selectors.msbQuantityInput).addClass(view.classes.quantityError);
      $(view.selectors.msbQuantityError + ' span').html('We only have ' + totalAvailableQuantity + ' items in stock');
      $(view.selectors.msbQuantityError).removeClass(view.classes.hideClass);
    },
    buildSuccessMessage: function buildSuccessMessage() {
      var successMessage;
      var itemLevelPromotion = pipCommonUtils.deepGet(viewModel, 'multiSkuBulkPromotion.msbSavingsMessage')
        && !!viewModel.multiSkuBulkPromotion.msbSavingsMessage.match(/\b(each|Each)\b/);

      if (viewModel.multiSkuBulkPromotion.msbSavingsAmount) {
        successMessage = 'You qualify for ' + viewModel.multiSkuBulkPromotion.msbSavingsAmount;
        successMessage += itemLevelPromotion ? ' off each product' : ' in savings';
      } else if (viewModel.multiSkuBulkPromotion.msbSavingsPercentage) {
        successMessage = 'You qualify for ' + viewModel.multiSkuBulkPromotion.msbSavingsPercentage;
        successMessage += itemLevelPromotion ? ' off each product' : ' off';
      }
      if (successMessage) {
        $(view.selectors.msbSavingsAppliedText).html(successMessage);
        $(view.selectors.msbSavingsApplied).removeClass(view.classes.hideClass);
      }
    },
    checkUpdateQualifyingPanel: function checkUpdateQualifyingPanel(itemModels) {
      $(view.selectors.msbSavingsApplied).addClass(view.classes.hideClass);
      if (itemModels) {
        if (viewModel.multiSkuBulkPromotion.minPurchaseAmount > 0) {
          var totalAmount = 0;
          itemModels.forEach(function forEachIterator(item) {
            if (viewModel.idMap[item.itemId]) {
              var itemPrice = (item.specialOfferPrice || item.unitPrice) || 0;
              totalAmount += parseFloat(itemPrice) * parseInt(item.quantity);
            }
          });

          if (totalAmount >= viewModel.multiSkuBulkPromotion.minPurchaseAmount) {
            view.buildSuccessMessage();
          }
        } else if (viewModel.multiSkuBulkPromotion.minPurchaseQuantity > 0) {
          var totalQuantity = 0;
          itemModels.forEach(function forEachIterator(item) {
            if (viewModel.idMap[item.itemId]) {
              totalQuantity += parseInt(item.quantity);
            }
          });
          if (totalQuantity >= viewModel.multiSkuBulkPromotion.minPurchaseQuantity) {
            view.buildSuccessMessage()
          }
        }
      }
    },
    updateCartData: function updateCartData(cartModel, itemDetails, options) {
      if (cartModel.itemModels || (cartModel.messagesModel && cartModel.messagesModel[0] && cartModel.messagesModel[0].shortDescription === 'Empty Shopping Cart')) {
        viewModel.updateCartCount(cartModel);
        view.updateDOM.msbSelectedItem();
        view.checkUpdateQualifyingPanel(cartModel.itemModels)
        pipCommonUtils.updateHeaderATCcounter();
        if (cartModel.itemModels && itemDetails && options && options.isCartIncrease) {
          pipEvents.multiSkuBulk.multiSkuBulkCartAdd.trigger({ cartModel: cartModel, itemDetails: itemDetails });
        }
      }
    },
    onSuccessAddToCart: function onSuccessAddToCart(cartModel, itemDetails, options) {
      view.afterCart();
      view.updateCartData(cartModel, itemDetails, options);
    },
    onCartError: function onCartError(cartModel, itemDetails, options) {
      view.afterCart();
      if (cartModel) {
        viewModel.checkCartError(cartModel, itemDetails);
        view.updateCartData(cartModel, itemDetails, options);
      } else {
        $(view.selectors.msbSavingsError).removeClass(view.classes.hideClass);
      }
    },
    disableElement: function disableElement(element, backgroundColor) {
      element.addClass(view.classes.disabled);
      if (element.type === 'text' || (element.length > 0 && element[0].type === 'text')) {
        element.attr('readonly', 'true');
      } else {
        element.attr(view.classes.disabled, 'true');
      }
      if (backgroundColor) {
        element.addClass(view.classes.bgColorFaded);
      }
    },
    enableElement: function enableElement(element, removeGrayBackground) {
      element.removeClass(view.classes.disabled);
      if (element.type === 'text' || (element.length > 0 && element[0].type === 'text')) {
        element.removeAttr('readonly');
      } else {
        element.removeAttr(view.classes.disabled);
      }
      if (removeGrayBackground) {
        element.removeClass(view.classes.bgColorFaded);
      }
    },
    beforeCart: function beforeCart() {
      $(view.selectors.msbSavingsError).addClass(view.classes.hideClass);
      $(view.selectors.msbItemSelectedImageOverlay).removeClass(view.classes.hideClass);
      $(view.selectors.msbSelectedImageText).addClass(view.classes.hideClass);
      $(view.selectors.msbItemSelectedImageOverlay).append(view.templates.msbCartUpdateSpinner);
      view.disableElement($(view.selectors.msbAddToCartButton));

      view.disableElement($(view.selectors.msbDecrement), true);
      view.disableElement($(view.selectors.msbIncrement), true);
      view.disableElement($(view.selectors.msbQuantityInput), true);
      view.disableElement($(view.selectors.msbListElement), true);
      if (this.isCartIncrease) {
        pipEvents.multiSkuBulk.multiSkuBulkCartStash.trigger(viewModel);
      }
    },
    afterCart: function afterCart() {
      $(view.selectors.msbOverlaySpinnerContainer).remove();
      $(view.selectors.msbSelectedImageText).removeClass(view.classes.hideClass);
      view.enableElement($(view.selectors.msbAddToCartButton));
      view.enableElement($(view.selectors.msbDecrement), true);
      view.enableElement($(view.selectors.msbIncrement), true);
      view.enableElement($(view.selectors.msbQuantityInput), true);
      view.enableElement($(view.selectors.msbListElement), true);
    },
  };

  var viewModel = {
    data: {},
    selectedItem: [],
    idMap: {},
    formatDollarPriceMoreThanThreeDigits: function formatDollarPriceMoreThanThreeDigits(dollars) {
      return dollars.toString().split('.')[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',').trim();
    },
    buildPricing: function buildPricing(value) {
      var anchorPrice = value.price.specialPrice || value.price.originalPrice || 0;
      var originalPrice = value.price.originalPrice || anchorPrice;
      var specialPrice = value.price.specialPrice || anchorPrice;
      var lessThanDollar = specialPrice < 1;
      var specialCents = specialPrice.toFixed(2).split('.')[1] || '00';

      return $.extend(true, value.price, {
        samePrice: originalPrice === specialPrice,
        lessThanDollar: lessThanDollar,
        originalDollars: viewModel.formatDollarPriceMoreThanThreeDigits(originalPrice),
        originalCents: originalPrice.toFixed(2).split('.')[1] || '00',
        specialDollars: viewModel.formatDollarPriceMoreThanThreeDigits(specialPrice),
        specialCents: lessThanDollar ? Number(specialCents).toString() : specialCents,
        dollarOffFormatted: '$' + value.price.dollarOff + (value.price.dollarOff.toString().split('.')[1] ? '' : '.00')
      });
    },
    productInfoCache: {
      productInfo: [],
      get: function get(key) {
        var cacheLength = this.productInfo.length;
        for (var productIndex = 0; productIndex < cacheLength; productIndex++) {
          var product = this.productInfo[productIndex];
          if (product.key === key) {
            this.productInfo.splice(productIndex, 1);
            this.productInfo.splice(cacheLength - 1, 0, product);
            return product.value;
          }
        }
      },
      add: function add(key, multiSkuBulkProducts) {
        if (this.productInfo.length >= view.constants.maxCacheLength) {
          this.productInfo.splice(0, 1);
        }
        this.productInfo.push({ key: key, value: multiSkuBulkProducts });
      }
    },
    checkSwatchPartOfPromo: function checkSwatchPartOfPromo() {
      return viewModel.currentPromotionId != viewModel.multiSkuBulkPromotion.promotionId;
    },
    sortByMainProduct: function sortByMainProduct() {
      var productData = Object.values(viewModel.idMap);
      productData.sort(function(itemSource, itemCompare) {
        return itemSource.itemId === pip.products.primary.data.itemId ? -1 : itemCompare.itemId === pip.products.primary.data.itemId ? 1 : 0;
      });
      return productData;
    },
    buildIdMap: function buildIdMap(data) {
      viewModel.idMap = {};
      data[view.constants.msbKey].forEach(function(value) {
        if (value.price) {
          value.price = viewModel.buildPricing(value);
          var rating = value.itemRating.averageRating.replace('.', '_');
          value['reviewURL'] = viewModel.multiSkuBulkPromotion.ratingsReviewsImageUrl.replace('{0}', rating);
          viewModel.idMap[value.itemId] = value;
        }
      });
    },
    createCartRequestItemDetails: function createCartRequestItemDetails(itemId, quantity, fulfillmentMethod, lineItemId) {
      return {
        itemId: itemId,
        quantity: quantity,
        lineItemId: lineItemId,
        fulfillmentMethod: fulfillmentMethod
      };
    },
    onItemQuantityIncreased: function onItemQuantityIncreased(inputQuantity) {
      var totalAvailableQuantity = viewModel.selectedItem.fulfillments.reduce(function reducer(accumulatorFulfillment, currentFulfillment) {
        return (accumulatorFulfillment + currentFulfillment.expectedQuantityAvailable);
      }, 0);
      var sthAvailableQuantity = 0;
      var bopisAvailableQuantity = 0;

      viewModel.selectedItem.fulfillments.forEach(function(fulfillment) {
        if (fulfillment.fulfillment === view.constants.shipToHome) {
          sthAvailableQuantity = fulfillment.expectedQuantityAvailable;
        } else if (fulfillment.fulfillment === view.constants.bopis) {
          bopisAvailableQuantity = fulfillment.expectedQuantityAvailable;
        }
      });
      if (inputQuantity > totalAvailableQuantity) {
        view.showItemQuantityExceedError(totalAvailableQuantity);
      } else {
        var updateCartData = [];
        var atcData = [];
        var bopisRequiredQuantity = 0;
        if (sthAvailableQuantity > 0) {
          var sthQuantity = inputQuantity;
          if (inputQuantity > sthAvailableQuantity) {
            sthQuantity = sthAvailableQuantity;
            bopisRequiredQuantity = inputQuantity - sthAvailableQuantity;
          } else if (viewModel.selectedItem.bopisLineItem) {
            sthQuantity -= viewModel.selectedItem.bopisQuantity;
          }
          if (viewModel.selectedItem.sthQuantity !== sthQuantity) {
            if (viewModel.selectedItem.sthLineItem) {
              updateCartData.push(viewModel.createCartRequestItemDetails(viewModel.selectedItem.itemId, sthQuantity, view.constants.shipToHome, viewModel.selectedItem.sthLineItem));
            } else {
              atcData.push(viewModel.createCartRequestItemDetails(viewModel.selectedItem.itemId, sthQuantity, view.constants.shipToHome));
            }
          }

          if (bopisRequiredQuantity > 0 && bopisRequiredQuantity !== viewModel.selectedItem.bopisQuantity) {
            if (viewModel.selectedItem.bopisLineItem) {
              updateCartData.push(viewModel.createCartRequestItemDetails(viewModel.selectedItem.itemId, bopisRequiredQuantity, view.constants.bopis, viewModel.selectedItem.bopisLineItem));
            } else {
              atcData.push(viewModel.createCartRequestItemDetails(viewModel.selectedItem.itemId, bopisRequiredQuantity, view.constants.bopis));
            }
          }

        } else if (bopisAvailableQuantity > 0 && viewModel.selectedItem.bopisLineItem) {
          updateCartData.push(viewModel.createCartRequestItemDetails(viewModel.selectedItem.itemId, inputQuantity, view.constants.bopis, viewModel.selectedItem.bopisLineItem));
        }
        viewModel.routeCartCall(updateCartData, atcData, true);
      }
    },
    routeCartCall: function routeCartCall(updateCartData, atcData, isCartIncrease) {
      if (updateCartData.length > 0 && atcData.length > 0) {
        viewModel.addToCartDirect(atcData, {
          success: function onSuccess() {
            viewModel.updateCart(updateCartData, { success: view.onSuccessAddToCart, error: view.onCartError, before: null, isCartIncrease: isCartIncrease });
          }, error: view.onCartError, before: view.beforeCart
        });
      } else {
        if (atcData.length > 0) {
          viewModel.addToCartDirect(atcData, {
            success: view.onSuccessAddToCart, error: view.onCartError, before: view.beforeCart, isCartIncrease: isCartIncrease
          });
        }
        if (updateCartData.length > 0) {
          viewModel.updateCart(updateCartData, { success: view.onSuccessAddToCart, error: view.onCartError, before: view.beforeCart, isCartIncrease: isCartIncrease });
        }
      }
    },
    onItemQuantityReduced: function onItemQuantityReduced(inputQuantity) {
      var updatedBopisQuantity = 0;
      var reduceOnSTH = 0;
      var updateCartData = [];
      if (viewModel.selectedItem.bopisQuantity > 0) {
        if (inputQuantity > viewModel.selectedItem.sthQuantity) {
          updatedBopisQuantity = inputQuantity - viewModel.selectedItem.sthQuantity;
        } else {
          reduceOnSTH = viewModel.selectedItem.sthQuantity - inputQuantity
        }
        updateCartData.push(viewModel.createCartRequestItemDetails(viewModel.selectedItem.itemId, updatedBopisQuantity, view.constants.bopis, viewModel.selectedItem.bopisLineItem));
      } else {
        reduceOnSTH = viewModel.selectedItem.sthQuantity - inputQuantity;
      }
      if (reduceOnSTH > 0 && viewModel.selectedItem.sthQuantity > 0) {
        updateCartData.push(viewModel.createCartRequestItemDetails(viewModel.selectedItem.itemId, viewModel.selectedItem.sthQuantity - reduceOnSTH, view.constants.shipToHome, viewModel.selectedItem.sthLineItem));
      }
      viewModel.routeCartCall(updateCartData, []);
    },
    checkCartError: function checkCartError(cartModel, itemDetails) {
      var errorLineItemIds = cartModel.errorModel.filter(function filterIterator(item) {
        return item.correlationId
      }).map(function mapIterator(item) {
        return item.correlationId
      });
      var updateLineItemIds = itemDetails.map(function mapIterator(item) { return item.lineItemId });
      if (errorLineItemIds.some(function someIterator(lineItem) { return updateLineItemIds.indexOf(lineItem) > -1 })) {
        $(view.selectors.msbSavingsError).removeClass(view.classes.hideClass);
      }
    },
    resetCartQuantity: function resetCartQuantity() {
      Object.keys(viewModel.idMap).forEach(function(key) {
        var item = viewModel.idMap[key];
        item.cartQuantity = 0;
        item.sthQuantity = 0;
        item.bopisQuantity = 0;
        item.sthLineItem = null;
        item.bopisLineItem = null;
      });
    },
    updateCartCount: function updateCartCount(cartModel) {
      var itemQuanityList = [];
      if (cartModel.itemModels) {
        cartModel.itemModels.reduce(function(accumulatorItemModel, currentItemMopdel) {
          if (!accumulatorItemModel[currentItemMopdel.itemId]) {
            accumulatorItemModel[currentItemMopdel.itemId] = { itemId: currentItemMopdel.itemId, quantity: 0 };
            itemQuanityList.push(accumulatorItemModel[currentItemMopdel.itemId])
          }
          accumulatorItemModel[currentItemMopdel.itemId].sthQuantity = accumulatorItemModel[currentItemMopdel.itemId].sthQuantity || 0;
          accumulatorItemModel[currentItemMopdel.itemId].bopisQuantity = accumulatorItemModel[currentItemMopdel.itemId].bopisQuantity || 0;
          var selectedFulfillment = currentItemMopdel.fulfillmentModel.filter(function filterIterator(fulfillment) { return fulfillment.selected });
          if (selectedFulfillment[0].fulfillmentMethod === view.constants.shipToHome) {
            accumulatorItemModel[currentItemMopdel.itemId].sthLineItem = currentItemMopdel.lineItemId;
            accumulatorItemModel[currentItemMopdel.itemId].sthQuantity = parseInt(currentItemMopdel.quantity);
          } else if (selectedFulfillment[0].fulfillmentMethod === view.constants.bopis) {
            accumulatorItemModel[currentItemMopdel.itemId].bopisLineItem = currentItemMopdel.lineItemId;
            accumulatorItemModel[currentItemMopdel.itemId].bopisQuantity = parseInt(currentItemMopdel.quantity);
          }
          return accumulatorItemModel;
        }, {});
      }

      viewModel.resetCartQuantity();
      $(view.selectors.msbQuantityCircle).addClass(view.classes.hideClass).html('0');
      itemQuanityList.forEach(function forEachIterator(itemQuanity) {
        var $msbCircle = $(view.selectors.msbListItemElementQuantityCircle(itemQuanity.itemId));
        if ($msbCircle.length > 0) {
          var cartQuantity = itemQuanity.sthQuantity + itemQuanity.bopisQuantity;

          if (cartQuantity > 0) {
            $msbCircle.html(cartQuantity);
            $msbCircle.removeClass(view.classes.hideClass);
          }
          if (itemQuanity.itemId === viewModel.selectedItem.itemId) {
            $(view.selectors.msbQuantityInput).val(cartQuantity);
            $(view.selectors.msbImageOverlayCartQuantity).html(cartQuantity)
          }
          viewModel.idMap[itemQuanity.itemId].cartQuantity = cartQuantity;
          viewModel.idMap[itemQuanity.itemId].sthQuantity = itemQuanity.sthQuantity;
          viewModel.idMap[itemQuanity.itemId].bopisQuantity = itemQuanity.bopisQuantity;
          viewModel.idMap[itemQuanity.itemId].sthLineItem = itemQuanity.sthLineItem;
          viewModel.idMap[itemQuanity.itemId].bopisLineItem = itemQuanity.bopisLineItem;
        }
      });
    },
    callCartOrchestration: function callCartOrchestration(itemDetails, localStoreId, url, options) {
      if (options && options.before && typeof options.before === 'function') {
        options.before();
      }
      var cartRequest = {
        'CartRequest': {
          'itemDetails': itemDetails,
          'localStoreId': localStoreId
        }
      };

      $.ajax({
        'url': pipDomain.getDomain() + url,
        'data': JSON.stringify(cartRequest),
        'contentType': 'application/json',
        'headers': {
          'accept': 'application/json'
        },
        'type': 'POST',
        'timeout': 20000,
        'success': function(response) {
          if (options && options.success && typeof options.success === 'function') {
            if (options.isCartIncrease) {
              viewModel.updateIncrementQuantity(itemDetails);
            }
            if (response.CartModel.errorModel) {
              if (options.error && typeof options.error === 'function') {
                options.error(response.CartModel, itemDetails, options);
              }
            } else {
              options.success(response.CartModel, itemDetails, options);
            }
          }
        },
        'error': function(response) {
          if (options && options.error && typeof options.error === 'function') {
            options.error(response.CartModel, itemDetails);
          }
        }
      });
    },
    updateIncrementQuantity: function updateIncrementQuantity(itemDetails) {
      itemDetails.forEach(function(items) {
        if (items.fulfillmentMethod === view.constants.bopis) {
          items.bopisQuantityIncrease = items.quantity - (viewModel.selectedItem.bopisQuantity || 0);
        } else if (items.fulfillmentMethod === view.constants.shipToHome) {
          items.sthQuantityIncrease = items.quantity - (viewModel.selectedItem.sthQuantity || 0);
        }
      });
    },
    addToCartDirect: function addToCartDirect(itemDetails, options) {
      var localStoreId = pip && pip.customer && pip.customer.localStore && pip.customer.localStore.storenumber;
      if (localStoreId) {
        if (itemDetails.length > 0) {
          itemDetails.forEach(function forEachIterator(item) {
            viewModel.updateFulfillment(item, localStoreId);
          });
        } else {
          viewModel.updateFulfillment(itemDetails, localStoreId);
          itemDetails = [itemDetails];
        }
        viewModel.callCartOrchestration(itemDetails, localStoreId, view.constants.addToCartURI, options);
      }
    },
    updateFulfillment: function updateFulfillment(itemDetails, localStoreId) {
      if (itemDetails.fulfillmentMethod === view.constants.bopis) {
        itemDetails.fulfillmentLocation = localStoreId;
      } else if (itemDetails.fulfillmentMethod === view.constants.shipToHome) {
        itemDetails.fulfillmentLocation = 'DirectShip';
      }
    },

    updateCart: function updateCart(itemDetails, options) {
      var localStoreId = pip && pip.customer && pip.customer.localStore && pip.customer.localStore.storenumber;
      if (localStoreId) {
        if (itemDetails.length > 0) {
          itemDetails.forEach(function forEachIterator(item) {
            viewModel.updateFulfillment(item, localStoreId);
          });
        }
        viewModel.callCartOrchestration(itemDetails, localStoreId, view.constants.cartUpdateURI, options);
      }
    },
    updateCartQuantityInItemList: function updateCartQuantityInItemList() {
      Object.keys(viewModel.idMap).forEach(function(key) {
        var item = viewModel.idMap[key];
        if (item.cartQuantity > 0) {
          var $msbCircle = $(view.selectors.msbListItemElementQuantityCircle(item.itemId));
          $msbCircle.html(item.cartQuantity);
          $msbCircle.removeClass(view.classes.hideClass);
        }
      });
    },
    updateCartQuantityFromMyCart: function updateCartQuantityFromMyCart() {
      $.ajax({
        'url': pipDomain.getDomain() + view.constants.cartLiteURI,
        'headers': {
          'accept': 'application/json'
        },
        'timeout': 20000,
        'success': function(response) {
          if (response.CartModel && response.CartModel.itemModels && response.CartModel.itemModels.length > 0) {
            view.onSuccessAddToCart(response.CartModel);
          }
        }
      });
    }
  };

  var model = {
    fetch: {
      msbModel: function msbModel() {
        var cachedProductInfo = viewModel.productInfoCache.get(viewModel.multiSkuBulkPromotion.promotionId);
        if (cachedProductInfo) {
          var deferred = $.Deferred().resolve({ multiSkuBulkProducts: cachedProductInfo, isCached: true });
          return deferred.promise();
        } else {
          return $.ajax({
            type: 'GET',
            url: view.constants.msbInfoURI + '?itemids=' + pip.products.primary.data.itemId + '&storeskus=' + viewModel.multiSkuBulkPromotion.itemList,
            timeout: 10000,
            dataType: 'json',
            cache: false
          });
        }
      }
    }
  };

  return {
    init: function init() {
      if (pip.features.multiSkuBulkPromotionUIEnabled && pip.multiSkuBulkPromotion) {
        viewModel.multiSkuBulkPromotion = pip.multiSkuBulkPromotion;
        multiSkuBulkAnalytics.init();
        view.updateDOM.msbMessage();
        if (viewModel.listenerAdded) {
          if (viewModel.isExpanded) {
            view.initView(true);
          }
        } else {
          view.initEventListeners();
        }
      }
    },
    view: view,
    viewModel: viewModel
  }
});

}.call(window));